module.exports = __webpack_public_path__ + "static/media/ar.0d8aaa22.svg";